import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Skeleton from "react-loading-skeleton";
import { MdOutlineBlock } from "react-icons/md";
import * as apicall from "../../components/Apicall";

export const CAR_SERVICE_INDUSTRY_ID = 8;

// ProtectedRoute only checks the user's role. Expense Management is also
// car-service-only, so a Vendor/Admin of another industry who types the URL
// lands here instead. Deliberately NOT AccessDenied.jsx: that clears
// localStorage and force-logs-out, which is right for a role violation but
// wrong for a legitimate user of a different industry.
//
// Industry comes from a fresh ezpMyProfile fetch (as App.js does), not the
// cached localStorage snapshot, which can hold a previous session's vendor
// right after login. vendorProfile is only the fallback if the fetch fails.
// The API enforces the same rule server-side, so this is UX, not security.
function IndustryGate({ children }) {
  const [state, setState] = useState("checking"); // checking | allowed | blocked

  useEffect(() => {
    let cancelled = false;
    (async () => {
      let industry = null;
      try {
        const res = await apicall.get("ezpMyProfile");
        industry = res?.success ? res.data?.[0]?.industry : null;
      } catch (e) {
        /* fall back to the cached profile below */
      }
      if (industry === null || industry === undefined) {
        try {
          industry = JSON.parse(localStorage.getItem("vendorProfile"))?.industry;
        } catch (e) {
          industry = null;
        }
      }
      if (!cancelled) setState(Number(industry) === CAR_SERVICE_INDUSTRY_ID ? "allowed" : "blocked");
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  if (state === "allowed") return children;

  if (state === "checking") {
    return (
      <div style={{ padding: "24px" }}>
        <Skeleton height={28} width={220} style={{ marginBottom: 16 }} />
        <Skeleton height={240} borderRadius={12} />
      </div>
    );
  }

  return (
    <div
      style={{
        flex: 1,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "60vh",
        color: "#6c757d",
        textAlign: "center",
        padding: 32,
      }}
    >
      <MdOutlineBlock size={48} style={{ marginBottom: 16, color: "#C9194A" }} />
      <h3 style={{ color: "#1a1a1a", marginBottom: 8 }}>Not available for your industry</h3>
      <p style={{ maxWidth: 380, fontSize: 14 }}>
        Expense Management is only available for car service businesses.
      </p>
      <Link to="/dashboard" className="btn btn-danger" style={{ borderRadius: 8, fontSize: 13, fontWeight: 600 }}>
        Back to Dashboard
      </Link>
    </div>
  );
}

export default IndustryGate;
